import { render, staticRenderFns } from "./AdminUniversalDirectory.vue?vue&type=template&id=31a33818&scoped=true"
import script from "./AdminUniversalDirectory.vue?vue&type=script&lang=js"
export * from "./AdminUniversalDirectory.vue?vue&type=script&lang=js"
import style0 from "./AdminUniversalDirectory.vue?vue&type=style&index=0&id=31a33818&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a33818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a33818')) {
      api.createRecord('31a33818', component.options)
    } else {
      api.reload('31a33818', component.options)
    }
    module.hot.accept("./AdminUniversalDirectory.vue?vue&type=template&id=31a33818&scoped=true", function () {
      api.rerender('31a33818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminUniversalDirectory.vue"
export default component.exports